export default __webpack_public_path__ + "static/media/colorpicker.9c45be7f.svg";